const LETTERS = 'abcdefghijklmnopqrstuvwxyz'.split('');
const VOWELS = 'aeiouy'.split('');
const FONTS = ['Greycliff', 'Baskerville'];
const fontLetters = {};

// Black
FONTS.forEach(fontFamily => {
  LETTERS.forEach(letter => {
    const fontNoSpace = fontFamily.replace(' ', '');
    const id = `${fontNoSpace.toLowerCase()}Black${letter.toUpperCase()}`;

    fontLetters[id] = {
      id,
      letter,
      fontFamily,
      title: letter,
      subtitle: 'Black',
      type: 'LETTER',
      color: 'BLACK',
      colorHex: '#000',
      fontStyle: fontFamily === 'Greycliff' ? 'TRADITIONAL' : 'BOOK',
      dropShadow: false,
    };
  });
});

// Orange
FONTS.forEach(fontFamily => {
  VOWELS.forEach(letter => {
    const fontNoSpace = fontFamily.replace(' ', '');
    const id = `${fontNoSpace.toLowerCase()}Orange${letter.toUpperCase()}`;

    fontLetters[id] = {
      id,
      letter,
      fontFamily,
      title: letter,
      subtitle: 'UF Orange',
      type: 'LETTER',
      color: 'ORANGE',
      colorHex: '#FD7E14',
      fontStyle: fontFamily === 'Greycliff' ? 'TRADITIONAL' : 'BOOK',
      dropShadow: false,
    };
  });
});

// One universal space character
fontLetters['space'] = {
  id: 'space',
  letter: '▨',
  fontFamily: FONTS[0],
  title: '▨',
  subtitle: 'Space',
  type: 'LETTER',
  color: 'BLACK',
  colorHex: '#dbdbdb',
  fontStyle: 'UNIVERSAL', // Prevent showing with filtered letters
  dropShadow: false,
}

export default fontLetters;
